import { MediaMatcher } from '@angular/cdk/layout';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import * as _ from 'lodash';
import moment from 'moment-timezone';

@Component({
    selector: 'pr-input-date',
    templateUrl: './pr-input-date.component.html',
    styleUrls: ['./pr-input-date.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputDateComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PrInputDateComponent,
        },
    ],
    standalone: false
})
export class PrInputDateComponent implements ControlValueAccessor, Validator {
  @ViewChild('input', { static: true }) inputRef: ElementRef;
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() label: string;
  @Input() isDefault: boolean = true;
  @Input() tooltipButton: string;
  @Input() highlightOnValue: boolean = false;
  @Input() highlightOnFocus: boolean = false;

  date: string = null;
  touched = false;
  disabled = false;
  hasValue: boolean = false;
  hasFocus: boolean = false;
  onChange = date => {};
  onTouched = () => {};
  mdq: MediaQueryList;

  constructor(
    private controlContainer: ControlContainer,
    private media: MediaMatcher,
  ) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit() {
    this.mdq = this.media.matchMedia(`(max-width: 992px)`);
  }

  onInputChange($event) {
    if (!$event.value) {
      this.date = this.inputRef.nativeElement.value;
    } else {
      try {
        let value = $event.target.value;
        this.date = this.toIso(value);
      } catch (error) {
        this.date = this.inputRef.nativeElement.value;
      }
    }
    this.hasValue = this.date && this.date.trim() !== '';
    this.onChange(this.date);
  }

  writeValue(value: any): void {
    this.date = value;
    this.hasValue =
      this.date && (!_.isString(this.date) || this.date.trim() !== '');
    if (this.date) {
      var date = moment(value).tz('Europe/Paris');
      setTimeout(
        () => (this.inputRef.nativeElement.value = date.format('DD/MM/YYYY')),
        0,
      );
    }
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  toIso(date): string {
    try {
      return this.formatMomentDate(date);
    } catch (e) {
      console.error('parsing date failed : ', e);
      this.control.setValue(moment().toISOString().split('.')[0] + 'Z');
      return this.formatMomentDate(null);
    }
  }

  formatMomentDate(date: string | null): string {
    if (date) {
      return moment(date).tz('Europe/Paris').hour(12).minute(1).format();
    }
    return moment().tz('Europe/Paris').hour(12).minute(1).format();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    if (
      control.value &&
      this.toIso(control.value) !== this.formatMomentDate(control.value)
    ) {
      return {
        validDate: true,
      };
    }
    return null;
  }
}
